import { isKnownSection } from '@sentra/contracts';
import type { TFunction } from 'i18next';

/**
 * The heading one group of the registration form is rendered under.
 *
 * **A known section translates; an administrator's own does not, and cannot.** `section` is free
 * text on the field definition — 64 characters an admin types into a box — so there is nowhere to
 * translate one from and no second column to hold the other language. The product's own sections are
 * a closed list with a catalogue entry each; anything else is rendered verbatim, which is the honest
 * answer rather than a guess at what the operator meant.
 *
 * A field with no section at all gets a heading too rather than being dropped in beside whichever
 * group came last, because a heading that is not about a field is worse than a vague one.
 */
export function sectionHeading(section: string | null, t: TFunction): string {
  if (section === null) {
    return t('person.section.unsorted');
  }
  // The template head is what makes `test:i18n` count every `person.section.*` key as used, so the
  // catalogue entries are not reported as orphans. Keep the literal prefix inline.
  return isKnownSection(section) ? t(`person.section.${section}`) : section;
}
